import { useEnv } from '../../../context/env-context';
import { SyncLogStatusAlert } from '../../sync';

export function ProductsSyncLogAlert() {
  const env = useEnv();

  if (!env?.platform) {
    return null;
  }

  return (
    <SyncLogStatusAlert
      syncFor={{ integration: env.platform, dataType: 'products' }}
      allowViewErrors={true}
    />
  );
}
